import { createContext, useContext, useState, useMemo, useCallback } from "react";

const translations = {
  it: {
    "nav.approach": "Il modello",
    "nav.portfolio": "Portafoglio",
    "nav.platform": "Piattaforma",
    "nav.method": "Metodo",
    "nav.stories": "Storie",
    "nav.criteria": "Criteri",
    "nav.pricing": "Prezzi",
    "nav.about": "Chi siamo",
    "nav.insights": "Insights",
    "nav.contact": "Contatti",
    "nav.admin": "Admin",
    "cta.sell": "Vendi la tua azienda",
    "cta.discover": "Scopri il modello",

    "hero.overline": "Holding permanente · Italia",
    "hero.title_1": "Compriamo",
    "hero.title_2": "aziende italiane.",
    "hero.title_3": "Per sempre.",
    "hero.lead": "GIANO acquisisce PMI italiane senza successione e le mantiene nel gruppo a tempo indeterminato. Nessun exit, nessuna vendita futura. Solo crescita paziente.",

    "stats.companies": "Aziende tipo",
    "stats.employees": "Dipendenti",
    "stats.revenue": "Ricavi aggregati",
    "stats.sectors": "Settori",
    "stats.headroom": "MLN €",

    "manifesto.overline": "Il manifesto",
    "manifesto.title_1": "L'Italia produce.",
    "manifesto.title_2": "Noi ",
    "manifesto.title_2_it": "proteggiamo",
    "manifesto.title_3": " chi produce.",
    "manifesto.p1": "Oltre 190.000 PMI italiane sono guidate da imprenditori con più di 60 anni. Il 42% non ha un piano di successione. Nei prossimi dieci anni, una parte sostanziale del tessuto produttivo italiano rischia di dissolversi in fondi stranieri o di chiudere le porte.",
    "manifesto.p2": "GIANO nasce come risposta. Un modello di proprietà permanente: acquistiamo, non vendiamo mai. Manteniamo il brand, la squadra, la sede. Investiamo capitale paziente per un orizzonte di 20, 30, 50 anni.",
    "manifesto.p3": "Non siamo un fondo di private equity. Non ci sono investitori esterni con orizzonti brevi. Siamo il rifugio a lungo termine per le eccellenze italiane di nicchia.",

    "approach.overline": "Il nostro modello",
    "approach.title": "Cinque principi. Un solo obiettivo.",
    "approach.subtitle": "Un approccio disciplinato, ispirato ai grandi holding europei di lungo periodo.",
    "approach.p1.title": "Proprietà permanente",
    "approach.p1.body": "Non vendiamo mai. Le aziende entrano nel gruppo per rimanervi generazioni.",
    "approach.p2.title": "Autonomia gestionale",
    "approach.p2.body": "Ogni azienda mantiene brand, management e strategia commerciale.",
    "approach.p3.title": "Capitale paziente",
    "approach.p3.body": "Nessuna pressione di exit. Reinvestiamo gli utili per crescere.",
    "approach.p4.title": "Standard di governance",
    "approach.p4.body": "Board, reporting mensile, KPI condivisi. Rigore senza burocrazia.",
    "approach.p5.title": "Rete di competenze",
    "approach.p5.body": "Le aziende del gruppo si scambiano clienti, fornitori, best practice.",

    "portfolio.overline": "Aziende target",
    "portfolio.title": "Il tipo di aziende con cui lavoriamo",
    "portfolio.subtitle": "Esempi illustrativi delle PMI italiane di nicchia con cui GIANO si interfaccia. Settori, dimensioni, storie di successione: le tipologie ricorrenti del capitalismo di prossimità italiano.",
    "portfolio.sector": "Settore",
    "portfolio.region": "Regione",
    "portfolio.year": "Anno di riferimento",
    "portfolio.revenue": "Ricavi",
    "portfolio.employees": "Dipendenti",
    "portfolio.all": "Tutti",

    "criteria.overline": "Cerchiamo",
    "criteria.title": "Chi cerchiamo",
    "criteria.subtitle": "Se la tua azienda risponde a questi criteri, parliamo.",
    "criteria.c1.title": "Ricavi",
    "criteria.c1.body": "Da €5M a €50M di fatturato annuo consolidato.",
    "criteria.c2.title": "EBITDA",
    "criteria.c2.body": "Margine positivo, EBITDA superiore a €1M ricorrente.",
    "criteria.c3.title": "Posizionamento",
    "criteria.c3.body": "Leadership in una nicchia difendibile con vantaggio competitivo dimostrabile.",
    "criteria.c4.title": "Geografia",
    "criteria.c4.body": "Sede operativa in Italia. Distribuzione anche internazionale è benvenuta.",
    "criteria.c5.title": "Storicità",
    "criteria.c5.body": "Almeno 10 anni di operatività, con storia finanziaria trasparente.",
    "criteria.c6.title": "Situazione",
    "criteria.c6.body": "Successione familiare non risolta, o volontà di continuità dopo l'uscita del fondatore.",

    "insights.overline": "Insights",
    "insights.title": "Idee e analisi",
    "insights.readmore": "Leggi",

    "contact.overline": "Parla con noi",
    "contact.title": "Il primo passo è una conversazione.",
    "contact.lead": "Il processo è riservato. Un incontro esplorativo, un NDA reciproco, e un'offerta chiara entro 30 giorni. Nessuna banca d'affari, nessun broker.",
    "contact.form.name": "Nome e cognome",
    "contact.form.email": "Email",
    "contact.form.company": "Nome azienda",
    "contact.form.role": "Il tuo ruolo",
    "contact.form.phone": "Telefono",
    "contact.form.region": "Regione",
    "contact.form.sector": "Settore",
    "contact.form.revenue": "Fascia di ricavi",
    "contact.form.message": "Raccontaci la tua azienda",
    "contact.form.submit": "Invia richiesta riservata",
    "contact.form.sent": "Grazie. Ti contatteremo entro 3 giorni lavorativi.",
    "contact.form.error": "Si è verificato un errore. Riprova.",
    "contact.revenue.opt1": "Meno di €5M",
    "contact.revenue.opt2": "€5M – €15M",
    "contact.revenue.opt3": "€15M – €30M",
    "contact.revenue.opt4": "€30M – €50M",
    "contact.revenue.opt5": "Oltre €50M",

    "footer.tagline": "Holding permanente per le PMI italiane.",
    "footer.rights": "Tutti i diritti riservati.",
    "footer.legal": "Note legali",
    "footer.privacy": "Privacy",

    "admin.login.title": "Area Riservata",
    "admin.login.subtitle": "Accedi con le credenziali GIANO",
    "admin.login.submit": "Accedi",
    "admin.dashboard": "Dashboard",
    "admin.portfolio": "Portafoglio",
    "admin.inquiries": "Richieste",
    "admin.insights": "Insights",
    "admin.ai": "GIANO Analytics",
    "admin.logout": "Esci",
    "admin.new": "Nuovo",
    "admin.edit": "Modifica",
    "admin.delete": "Elimina",
    "admin.save": "Salva",
    "admin.cancel": "Annulla",
  },
  en: {
    "nav.approach": "Model",
    "nav.portfolio": "Portfolio",
    "nav.platform": "Platform",
    "nav.method": "Method",
    "nav.stories": "Stories",
    "nav.criteria": "Criteria",
    "nav.pricing": "Pricing",
    "nav.about": "About",
    "nav.insights": "Insights",
    "nav.contact": "Contact",
    "nav.admin": "Admin",
    "cta.sell": "Sell your company",
    "cta.discover": "Discover the model",

    "hero.overline": "Permanent holding · Italy",
    "hero.title_1": "We buy",
    "hero.title_2": "Italian companies.",
    "hero.title_3": "Forever.",
    "hero.lead": "GIANO acquires Italian SMEs with no succession plan and keeps them in the group indefinitely. No exit, no future sale. Only patient growth.",

    "stats.companies": "Sample companies",
    "stats.employees": "Employees",
    "stats.revenue": "Aggregate revenue",
    "stats.sectors": "Sectors",
    "stats.headroom": "M €",

    "manifesto.overline": "The manifesto",
    "manifesto.title_1": "Italy produces.",
    "manifesto.title_2": "We ",
    "manifesto.title_2_it": "protect",
    "manifesto.title_3": " who produces.",
    "manifesto.p1": "Over 190,000 Italian SMEs are run by entrepreneurs older than 60. 42% have no succession plan. In the next decade, a substantial part of Italy's productive fabric risks being sold to foreign funds or shutting down.",
    "manifesto.p2": "GIANO is the answer. A permanent ownership model: we buy, we never sell. We keep the brand, the team, the headquarters. We invest patient capital over a 20, 30, 50-year horizon.",
    "manifesto.p3": "We are not a private equity fund. There are no external investors with short horizons. We are the long-term home for Italian niche excellence.",

    "approach.overline": "Our model",
    "approach.title": "Five principles. One purpose.",
    "approach.subtitle": "A disciplined approach inspired by the great long-term European holdings.",
    "approach.p1.title": "Permanent ownership",
    "approach.p1.body": "We never sell. Companies join the group to stay for generations.",
    "approach.p2.title": "Managerial autonomy",
    "approach.p2.body": "Each company keeps its brand, management and commercial strategy.",
    "approach.p3.title": "Patient capital",
    "approach.p3.body": "No exit pressure. We reinvest profits to grow.",
    "approach.p4.title": "Governance standards",
    "approach.p4.body": "Board, monthly reporting, shared KPIs. Rigour without bureaucracy.",
    "approach.p5.title": "Network of skills",
    "approach.p5.body": "Group companies share clients, suppliers, best practices.",

    "portfolio.overline": "Target companies",
    "portfolio.title": "The kind of companies we work with",
    "portfolio.subtitle": "Illustrative examples of the niche Italian SMEs GIANO engages with. Sectors, scale, succession stories: the recurring archetypes of Italian proximity capitalism.",
    "portfolio.sector": "Sector",
    "portfolio.region": "Region",
    "portfolio.year": "Reference year",
    "portfolio.revenue": "Revenue",
    "portfolio.employees": "Employees",
    "portfolio.all": "All",

    "criteria.overline": "We look for",
    "criteria.title": "Who we look for",
    "criteria.subtitle": "If your company meets these criteria, let's talk.",
    "criteria.c1.title": "Revenue",
    "criteria.c1.body": "€5M to €50M in consolidated annual revenue.",
    "criteria.c2.title": "EBITDA",
    "criteria.c2.body": "Positive margin, recurring EBITDA above €1M.",
    "criteria.c3.title": "Positioning",
    "criteria.c3.body": "Leadership in a defensible niche with demonstrable competitive advantage.",
    "criteria.c4.title": "Geography",
    "criteria.c4.body": "Operations based in Italy. International distribution welcome.",
    "criteria.c5.title": "Track record",
    "criteria.c5.body": "At least 10 years of operations with a transparent financial history.",
    "criteria.c6.title": "Situation",
    "criteria.c6.body": "Unresolved family succession, or willingness for continuity after the founder's exit.",

    "insights.overline": "Insights",
    "insights.title": "Ideas and analysis",
    "insights.readmore": "Read",

    "contact.overline": "Talk to us",
    "contact.title": "The first step is a conversation.",
    "contact.lead": "The process is confidential. An exploratory meeting, a mutual NDA, and a clear offer within 30 days. No investment banks, no brokers.",
    "contact.form.name": "Full name",
    "contact.form.email": "Email",
    "contact.form.company": "Company name",
    "contact.form.role": "Your role",
    "contact.form.phone": "Phone",
    "contact.form.region": "Region",
    "contact.form.sector": "Sector",
    "contact.form.revenue": "Revenue range",
    "contact.form.message": "Tell us about your company",
    "contact.form.submit": "Send confidential request",
    "contact.form.sent": "Thank you. We will contact you within 3 business days.",
    "contact.form.error": "Something went wrong. Please try again.",
    "contact.revenue.opt1": "Less than €5M",
    "contact.revenue.opt2": "€5M – €15M",
    "contact.revenue.opt3": "€15M – €30M",
    "contact.revenue.opt4": "€30M – €50M",
    "contact.revenue.opt5": "Over €50M",

    "footer.tagline": "Permanent holding for Italian SMEs.",
    "footer.rights": "All rights reserved.",
    "footer.legal": "Legal",
    "footer.privacy": "Privacy",

    "admin.login.title": "Restricted Area",
    "admin.login.subtitle": "Sign in with your GIANO credentials",
    "admin.login.submit": "Sign in",
    "admin.dashboard": "Dashboard",
    "admin.portfolio": "Portfolio",
    "admin.inquiries": "Inquiries",
    "admin.insights": "Insights",
    "admin.ai": "GIANO Analytics",
    "admin.logout": "Sign out",
    "admin.new": "New",
    "admin.edit": "Edit",
    "admin.delete": "Delete",
    "admin.save": "Save",
    "admin.cancel": "Cancel",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return localStorage.getItem("giano_lang") || "it";
  });

  const setLanguage = useCallback((l) => {
    setLang(l);
    localStorage.setItem("giano_lang", l);
  }, []);

  const t = useCallback((key) => translations[lang][key] || key, [lang]);

  const value = useMemo(() => ({ lang, setLanguage, t }), [lang, setLanguage, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
